<template>
  <v-content>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md5 lg4 xl3>
            <v-card class="elevation-12 mt-4">
              <progress-bar :show="busy"></progress-bar>
              <v-img height="160px" contain :src="`${appUrl}/storage/img/logo_columbus_2.png`"></v-img>
              <v-card-title class="text-lg-center">
                <h3 class="headline mb-0 primary--text font-weight-bold">{{ $t('login') }}</h3>
              </v-card-title>
              <form @submit.prevent="login" @keydown="form.onKeydown($event)">
                <v-card-text>

                  <!-- Username -->
                  <text-input
                    :form="form"
                    :label="$t('username_login')"
                    :v-errors="errors"
                    :value.sync="form.username"
                    name="username"
                    prepend="person_outline"
                    v-validate="'required'"
                    :autofocus="true"
                    autocomplete="user-columbus"
                  ></text-input>

                  <!-- Password -->
                  <password-input
                    :v-errors="errors"
                    :form="form"
                    :value.sync="form.password"
                    prepend="lock_outline"
                    v-validate="'required'"
                    name="password"
                    autocomplete="password-columbus"
                  ></password-input>

                  <!-- Remember Me -->
                  <v-checkbox
                    :label="$t('remember_me')"
                    color="primary"
                    type="checkbox"
                    v-model="remember"
                    value="true"
                  ></v-checkbox>

                  <submit-button :form="form" block large :label="$t('login')"></submit-button>

                </v-card-text>
                <v-card-actions justify-center>
                  <v-layout justify-center row wrap>
                      <v-btn v-if="showRegister"  :to="{ name: 'register' }" flat color="primary">No soy del Columbus School (Registrarme)</v-btn>
                  </v-layout>
                </v-card-actions>
              </form>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog v-model="dialog" persistent max-width="490">
        <v-card>
          <v-card-title class="headline warning white--text">{{$t('no_login_verification')}}</v-card-title>
          <v-card-text>{{$t('no_login_verification_text')}}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              @click="resendEmail"
              :loading="mailLoading"
              :disabled="mailLoading"
              >{{$t('resend_verification')}}</v-btn>
            <v-btn color="secondary" flat @click="dialog = false">{{$t('close')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-content>
</template>

<script>
import Form from 'vform'
import axios from 'axios'

export default {
  name: 'login-view',
  metaInfo () {
    return { title: this.$t('login') }
  },
  data: () => ({
    dialog: false,
    form: new Form({
      username: '',
      password: ''
    }),
    appUrl: window.config.appUrl,
    eye: true,
    remember: false,
    busy: false,
    mailLoading: false,
    showRegister: false,
  }),
  created () {
    this.getConfiguration();
  },
  methods: {
    async login () {
      if (await this.formHasErrors()) return
      this.busy = true
      // Submit the form.
      const { data } = await this.form.post('/api/login')

      if (data.error && !data.verified) {
        this.dialog = true
        this.busy = false

        this.$store.dispatch('setUserVerified', false)
        // Save the token.
        this.$store.dispatch('saveToken', {
          token: data.token,
          remember: this.remember
        })
        return
      }

      this.$store.dispatch('setUserVerified', true)

      // Save the token.
      this.$store.dispatch('saveToken', {
        token: data.token,
        remember: this.remember
      })
      // Fetch the user.
      await this.$store.dispatch('fetchUser')

      this.busy = false
      // Redirect home.
      this.$router.push(this.$route.query.redirect || '/home')

      //Fetch menu user.
      await this.$store.dispatch('fetchMenu')

    },
    resendEmail() {
      this.mailLoading = true
      axios.get('/api/email/resend')
        .then(resp => {
          if (resp.status === 200) {
            this.dialog = false
            this.mailLoading = false
          }
        })
        .catch(error => console.log(error))
    },
    getConfiguration() {
      axios.get('/api/configuration/APP_REGISTER')
        .then(resp => {
          if (resp.status === 200) {
            this.showRegister = resp.data.int_value === 1
          }
        })
        .catch(err => console.log(err))
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/auth/login.vue